import { get } from 'lodash/object';
import { extractSeatsFromModel } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/extractSeatsFromSelection';
import { SEAT_PURCHASE_STATUS_FREE } from '%paysera_seat_selection/js/seatSelection/config/constants';
import SeatEnumerationError from '%paysera_seat_selection/js/seatSelection/redux/component/orm/errors/SeatEnumerationError';
import Translator from '%app/js/common/services/translator';

class SeatEnumerationValidator {
    validateRowEnumeration(row, labelLeft, labelRight) {
        if (
            extractSeatsFromModel(row).some(seat => seat.purchaseStatus !== SEAT_PURCHASE_STATUS_FREE)
            && (
                (get(row, 'labelLeft.text', null) !== get(labelLeft, 'text', null))
                || get(row, 'labelRight.text', null) !== get(labelRight, 'text', null)
            )
        ) {
            throw new SeatEnumerationError(Translator.trans(
                'seat_selection.seat_enumeration_error.row',
                {
                    row: get(row, 'labelLeft.text') || get(row, 'labelRight.text'),
                    sector: get(row, 'sector.label.text'),
                },
            ));
        }
    }

    validateSeatEnumeration(seat, label) {
        if (seat.purchaseStatus !== SEAT_PURCHASE_STATUS_FREE && seat.label.text !== label.text) {
            throw new SeatEnumerationError(Translator.trans(
                'seat_selection.seat_enumeration_error.seat',
                {
                    seat: get(seat, 'label.text'),
                    row: get(seat, 'row.labelLeft.text') || get(seat, 'row.labelRight.text'),
                    sector: get(seat, 'row.sector.label.text'),
                },
            ));
        }
    }
}

export default new SeatEnumerationValidator();
